import React from "react";
import ProgramTemplate from "@/components/ProgramTemplate";
import { PROGRAM_CI_45 } from "@/lib/programs/ciudadesImperiales45";

export default function CiudadesImperiales45Page() {
  return <ProgramTemplate program={PROGRAM_CI_45} variant="ci" showJourneyChronology />;
}
